import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {utils} from "@mc/mc-legacy";
import * as React from "react";
import {Component} from "react";
import {Nav, NavItem, NavLink} from "reactstrap";
import * as objednavkaActions from "../actions/objednavkaActions";
import * as EnumStavObjednavka from "../api/gen/cgo/EnumStavObjednavka";
import * as EnumStavObjednavkaInfo from "../api/EnumStavObjednavkaInfo";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Komopnenta zobrazující přepínatelné záložky pro filtr objednávek na seznamu objednávek.
 * Záložky zobrazují počty objednávek.
 */
class ObjednavkyListCountStats extends Component<WithTranslation> {
    static propTypes = {
        selectedStav: PropTypes.string.isRequired, // aktuálně vybraný stav
        onChange: PropTypes.func.isRequired, // změna stavu
    };

    componentDidMount() {
        this.fetchData();
    }

    UNSAFE_componentWillReceiveProps() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(objednavkaActions.fetchObjednavkyCountStatsIfNeeded());
    };

    render() {
        const {selectedStav, onChange, objednavkyListCountStats, t} = this.props;

        const stavyOrdered = [
            EnumStavObjednavka.CEKA,
            EnumStavObjednavka.ZDCEN,
            EnumStavObjednavka.ZPRAC,
            EnumStavObjednavka.VYRIZ,
            EnumStavObjednavka.EXP,
            EnumStavObjednavka.STORN
        ];

        if (objednavkyListCountStats.fetched) {
            const stavyKeys = Object.keys(objednavkyListCountStats.data.stavObjednavkaStats);
            const stavyFiltered = stavyOrdered.filter(stav => stavyKeys.includes(stav));

            return <Nav className="nav-links">
                <NavItem className="link-inline">
                    <NavLink onClick={() => onChange(objednavkaActions.FILTR_ZPRACOVAVANE)} active={selectedStav === objednavkaActions.FILTR_ZPRACOVAVANE}>
                        {t('order.currently_processing_count', {count: objednavkyListCountStats.data.aktualneZpracovavane})}
                    </NavLink>
                </NavItem>
                {stavyFiltered.map(stav => <NavItem className="link-inline" key={stav}>
                    <NavLink onClick={() => onChange(stav)} active={selectedStav === stav}>
                        {EnumStavObjednavkaInfo.getCaption(stav, t)} ({objednavkyListCountStats.data.stavObjednavkaStats[stav]})
                    </NavLink>
                </NavItem>)}
                <NavItem className="link-inline">
                    <NavLink onClick={() => onChange(objednavkaActions.FILTR_VSE)} active={selectedStav === objednavkaActions.FILTR_VSE || selectedStav == null}>
                        {t('all')} ({objednavkyListCountStats.data.celkem})
                    </NavLink>
                </NavItem>
            </Nav>
        } else {
            return <Nav className="nav-links"/>
        }
    }
}

function mapStateToProps(state) {
    return {
        objednavkyListCountStats: utils.storeFromArea(state, objednavkaActions.OBJEDNAVKY_LIST_COUNT_STATS_AREA),
    };
}

export default connect(mapStateToProps)(withTranslation()(ObjednavkyListCountStats));
